<form [formGroup]="editUserPermissionForm">
    @if (($any(editUserPermissionForm && editUserPermissionForm.controls) | keyvalue)?.length) {
        <div>
            @for (ftGroupControl of $any(editUserPermissionForm.controls) | keyvalue: sorter; track ftGroupControl; let i = $index) {
                <div class="inputGroup">
                    <label [for]="ftGroupControl.key">{{ shijiAccessZoneLabels[$any(ftGroupControl.key)] }}</label>
                    <input type="checkbox" [id]="ftGroupControl.key" [formControlName]="$any(ftGroupControl.key)" />
                </div>
            }
        </div>
    }
</form>
